// Mirrors backend/src/constants/navVisibility.js's NAV_SECTIONS — the seven
// nav sections an admin can hide platform-wide, in nav display order.
// "Settings" is deliberately excluded, same as the backend: every seller
// always needs their own account settings.
//
// "Listings" is left out of this list entirely for now — it's a live
// marketplace-sync view, and the current MVP phase is the file-download
// flow (fill the form, download, upload manually), not live API sync. The
// route/page/backend are untouched and ready for when that phase starts;
// this just keeps it out of the nav so it isn't promoted as something to
// use yet. Re-add `{ key: 'listings', to: '/listings', label: 'Listings' }`
// (in this position) when that phase begins.
export const NAV_ROUTE_MAP = [
  // Labelled Home, not Dashboard: it is the screen a seller lands on after
  // signing in, and it leads with what to do next rather than with metrics.
  { key: 'dashboard', to: '/dashboard', label: 'Home' },
  // "Listings", not "Products". What lives here is not a product — it is this
  // seller's listing OF a product: their SKU, their price, their stock, ready
  // for a marketplace. The catalogue holds the products; this holds what the
  // seller is going to sell. The nav key stays `products` because the backend
  // visibility setting is keyed on it, and renaming a stored key to change a
  // label is how a saved preference silently stops applying.
  { key: 'products', to: '/products', label: 'Listings' },
  { key: 'orders', to: '/orders', label: 'Orders' },
  { key: 'inventory', to: '/inventory', label: 'Inventory' },
  { key: 'catalog', to: '/catalog', label: 'Catalog' },
  { key: 'reports', to: '/reports', label: 'Reports' }
];

// Where to land a user whose intended page (or the default "/") is hidden.
// Admins always see everything, so they always land on Dashboard; a seller
// lands on the first section still visible to them, falling back to
// Settings (never gated) if every toggleable section is off.
export function getDefaultRoute(navVisibility, isAdmin) {
  // An admin's home is the admin dashboard. Landing them on the seller home —
  // "0 products waiting to be listed", "Unmetered credits" — showed the person
  // running the platform a screen about a shop they do not have.
  if (isAdmin) return '/admin';
  const firstVisible = NAV_ROUTE_MAP.find((item) => navVisibility?.[item.key] !== false);
  return firstVisible ? firstVisible.to : '/settings';
}
